import { INTRO_CLOSED } from "App/js/events.js";
import Logo from "App/js/logo";
import { Bus } from "App/js/simple-bus.js";
import Utils from "App/js/utils.js";
import i18n from "../config/i18n";

import defaultTemplate from "../pages/intro/default.html";
import playTemplate from "../pages/intro/play.html";

const coverTemplates = {
  play: playTemplate,
  default: defaultTemplate,
};

class Intro {
  constructor(container, minMode, config) {
    this.minMode = minMode;
    this.active = true;
    this.container = container.querySelector(".intro");
    this.config = config;
  }
  show(project, status, onClick) {
    if (this.config.OgImage) {
      this.container.style.backgroundImage = `url(${this.config.OgImage})`;
    }
    const title = project.Name;
    this.status = status;

    // Use cover template
    if (this.config.CoverName === "none") {
      return onClick();
    }
    if (!(this.config.CoverName in coverTemplates)) {
      console.warn(
        `Cover template ${this.config.CoverName} not found. Falling back to default.`
      );
      this.config.CoverName = "default";
    }

    const validationResult = this.validateTemplate(
      coverTemplates[this.config.CoverName]
    );
    if (validationResult.valid) {
      this.container.innerHTML = validationResult.html;
      document.head.appendChild(validationResult.styles);
    } else {
      return onClick();
    }

    if (!this.minMode) {
      // Insert company logo or default image
      if (project.GroupLogoUrl !== null) {
        new Logo(project, "GroupLogoUrl", ".company-logo").show();
      } else {
        const img360 = document.querySelector(".img360");
        if (img360) {
          Utils.removeClass(img360, "hidden");
        }
      }

      // Insert owner awatar
      new Logo(project, "OwnerAvatarUrl", ".owner-avatar").show();
    }

    // Set title
    const introTitle = this.container.querySelector(".intro-title");
    if (introTitle && this.config.CoverTitle) {
      const titleControl = document.createElement("h4");
      titleControl.classList.add("intro-title--bold");
      titleControl.innerText = this.config.CoverTitle;
      introTitle.innerHTML = titleControl.outerHTML;
    }

    // Set button text
    const button = this.container.querySelector(".start-button");
    if (button && this.config.CoverButton) {
      button.innerText = this.config.CoverButton;
      const icon = document.createElement("i");
      icon.classList.add("fas", "fa-play-circle");
      button.appendChild(icon);
    }

    // Set description
    const introDescription = this.container.querySelector(".description");
    if (introDescription) {
      if (this.config.CoverDesctiption) {
        introDescription.innerText = this.config.CoverDesctiption;
      } else if (!this.minMode) {
        introDescription.innerText = i18n.t("txtIntroDescription");
      } else {
        Utils.addClass(introDescription, "hidden");
      }
    }

    this.showStartButton(onClick);

    Utils.addClass(this.container, " visible");
    if (this.container.clientHeight <= 500) {
      this.container.classList.add("isMobile");
    }
    window.addEventListener("resize", (e) => {
      if (e.target.innerHeight <= 500) {
        this.container.classList.add("isMobile");
      }
      if (e.target.innerHeight > 500) {
        this.container.classList.remove("isMobile");
      }
    });
  }
  showLoadFailed(serverNotResponse) {
    const titleControl = this.container.querySelector(".title");
    if (titleControl) {
      titleControl.innerText = "Not found";
    }
    const infoControl = this.container.querySelector(".info");

    if (infoControl) {
      if (serverNotResponse) {
        infoControl.innerText = i18n.t("txtServerError");
      } else {
        infoControl.innerText = i18n.t("txtWalkDisabled");
      }
    }

    Utils.addClass(this.container, " visible");

    const button = this.container.querySelector(".start-button");
    if (button) {
      button.remove();
    }
    //let buttonText = 'Wirtualny spacer nie istnieje lub został usunięty.';
    //button.innerText = buttonText;
  }
  getLastVisibleChild(control, max) {
    if (control.children.length === 0) {
      return control;
    }
    for (let i = 0; i < control.children.length; i++) {
      const child = control.children[i];
      const bottom = child.getBoundingClientRect().bottom;
      if (bottom > max) {
        return this.getLastVisibleChild(child, max);
      }
    }
    return null;
  }
  hide(cb) {
    this.active = false;
    Utils.removeClass(this.container, " visible");
    // this.container.parentElement.style.display = 'none';
    document.querySelector(".watermark").classList.remove("watermark--intro");
    let viewport = document.getElementById("viewport");
    viewport.classList.remove("blur");
    Bus.post(INTRO_CLOSED);
    if (typeof cb === "function") {
      cb(this);
    }
  }
  showStartButton(onClick) {
    const button = this.container.querySelector(".start-button");
    const container = button.parentElement;

    if (this.status == 1) {
      container.innerText = "";
      var node = document.createElement("p");
      node.classList = "info";
      node.innerText = i18n.t("txtWalkDisabled");
      container.appendChild(node);
    } else if (this.status == 2) {
      button.addEventListener("click", onClick);
      Utils.addClass(button, "active");
    } else {
      console.warn("Status: " + this.status);
    }
  }
  validateTemplate(source) {
    const parser = new DOMParser();
    const template = parser.parseFromString(source, "text/html");

    const templateContainer = template.querySelector("main");
    if (!templateContainer || !templateContainer.hasChildNodes()) {
      console.error(
        "[INVALID TEMPLATE] Template is empty or invalid. Add HTML inside the <main> tag."
      );
      return {
        valid: false,
      };
    }
    const styles = template.querySelector("style");
    if (!styles) {
      console.error("[INVALID TEMPLATE] Template is missing a <style> tag.");
      return {
        valid: false,
      };
    }
    const startButton = template.querySelector(".start-button");
    if (!startButton) {
      console.error(
        "[INVALID TEMPLATE] Template is missing a .start-button element."
      );
      return {
        valid: false,
      };
    }
    return {
      valid: true,
      html: templateContainer.innerHTML,
      styles: styles,
    };
  }
}

export default Intro;
